import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ibmXForceExchange = defineConnector({
  identifier: "ibmXForceExchange",
  name: "IBM X Force Exchange",
  tagLine: "Threat intelligence exchange",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api.xforce.ibmcloud.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: app.secret.apiPassword,
    }),
  steps: [
    {
      title: "Create credentials in IBM X Force Exchange",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://api.xforce.ibmcloud.com/doc/](https://api.xforce.ibmcloud.com/doc/) to create credentials with the permissions you want 3B to use.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
        },
        {
          kind: "input",
          label: "API password",
          required: true,
          target: {
            kind: "secrets",
            field: "apiPassword",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api.xforce.ibmcloud.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api.xforce.ibmcloud.com/auth/api_key")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
